/** Learner curriculum enrollment — educational track, independent of UI locale / tenant language. */

export type InstructionalTrack = 'tamil' | 'malay';

export type LearnerCurriculumResolutionSource =
  | 'explicit_enrollment'
  | 'legacy_malay_poc_allocation'
  | 'unresolved';

export interface ResolvedLearnerCurriculum {
  ok: boolean;
  resolution_source: LearnerCurriculumResolutionSource;
  tenant_id: string;
  roster_student_id?: string | null;
  platform_user_id?: string | null;
  platform_grade?: number | null;
  instructional_track?: InstructionalTrack | null;
  subject?: string | null;
  school_level?: string | null;
  subject_level?: string | null;
  curriculum_id?: string | null;
  curriculum_version?: string | null;
  curriculum_name?: string | null;
  enrollment_id?: string | null;
  message?: string | null;
}

export interface LearnerCurriculumMeResponse {
  curriculum: ResolvedLearnerCurriculum;
}

export function isLearnerTamilCurriculum(
  curriculum: ResolvedLearnerCurriculum | null | undefined
): boolean {
  return Boolean(curriculum?.ok && curriculum.instructional_track === 'tamil');
}

export function isLearnerMalayCurriculum(
  curriculum: ResolvedLearnerCurriculum | null | undefined
): boolean {
  return Boolean(curriculum?.ok && curriculum.instructional_track === 'malay');
}

export function isLearnerCurriculumResolved(
  curriculum: ResolvedLearnerCurriculum | null | undefined
): boolean {
  return Boolean(curriculum?.ok && curriculum.instructional_track);
}
